import Alert from "antd/es/alert";
import Button from "antd/es/button";
import Form from "antd/es/form";
import SendOutlined from "@ant-design/icons/SendOutlined";
import { RenderableSurveyData } from "../types";
import FieldsContainer from "components/Fields";
import { Store } from "antd/es/form/interface";

interface SurveyFormProps {
  jsonData: RenderableSurveyData;
  handleFormSubmit: (values: any) => void;
  initialValues: () => Store | undefined;
  isLoading: boolean;
  submitError?: string;
}

const SurverForm = ({
  jsonData,
  handleFormSubmit,
  initialValues,
  isLoading,
  submitError,
}: SurveyFormProps) => {
  const textWithLineBreaks = (text = "") => {
    return text.split("\n").map((line, index) => (
      <div key={index}>
        {line}
      </div>
    ));
  };

  const headerText = jsonData.surveyTemplate.headerText;
  const footerText = jsonData.surveyTemplate.footerText;

  return (
    <div className="surveyContent">
      {headerText && (
        <div className="surveyIntro">{textWithLineBreaks(headerText)}</div>
      )}

      <Form
        className="surveyForm"
        onFinish={handleFormSubmit}
        initialValues={initialValues()}
        noValidate
        labelWrap={true}
        labelAlign="left"
        colon={false}
      >
        <FieldsContainer fieldsData={jsonData?.groups} />

        {submitError && (
          <Alert
            className="surveyAlert"
            type="error"
            showIcon
            message={submitError}
          />
        )}

        <div className="surveyActions">
          <Button
            type="primary"
            htmlType="submit"
            className="btnSend"
            loading={isLoading}
            icon={<SendOutlined />}
          >
            Відправити
          </Button>
        </div>
      </Form>

      {footerText && (
        <div className="surveyFooter">{textWithLineBreaks(footerText)}</div>
      )}
    </div>
  );
};

export default SurverForm;
